import Swal from 'sweetalert2';
import api from "./Api";
import { IRegraConciliacaoEmpresa } from '../interfaces/IRegraConciliacaoEmpresa';

class RegraConciliacaoService {
  async getDados(ativo: boolean | null = true): Promise<IRegraConciliacaoEmpresa[]> {
    try {
      const query = ativo === null ? '' : `?ativo=${ativo}`;
      const { data: result } = await api.get<IRegraConciliacaoEmpresa[]>(`RegraConciliacao${query}`, {
        baseURL: process.env.REACT_APP_API_CORE_URL ?? 'https://api-core.dev.painel-agholmes.com/api/v3/'
      });

      return result;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });

      return [];
    }
  }

  async ativar(id: number, funcaoSucesso?: () => void): Promise<boolean> {
    try {
      await api.patch(`RegraConciliacao/${id}/ativar`, undefined, {
        baseURL: process.env.REACT_APP_API_CORE_URL ?? 'https://api-core.dev.painel-agholmes.com/api/v3/'
      });
      funcaoSucesso && funcaoSucesso();
      Swal.fire({ text: 'Regra ativada com sucesso', timer: 3000, icon: 'success', showConfirmButton: false });
      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.response?.data?.message || error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });
      return false;
    }
  }

  async inativar(id: number, funcaoSucesso?: () => void): Promise<boolean> {
    try {
      await api.patch(`RegraConciliacao/${id}/inativar`, undefined, {
        baseURL: process.env.REACT_APP_API_CORE_URL ?? 'https://api-core.dev.painel-agholmes.com/api/v3/'
      });
      funcaoSucesso && funcaoSucesso();
      Swal.fire({ text: 'Regra inativada com sucesso', timer: 3000, icon: 'success', showConfirmButton: false });
      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.response?.data?.message || error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });
      return false;
    }
  }

  async getById(id: number): Promise<any> {
    try {
      const { data: result } = await api.get<any>(`RegraConciliacao/${id}`, {
        baseURL: process.env.REACT_APP_API_CORE_URL ?? 'https://api-core.dev.painel-agholmes.com/api/v3/'
      });

      return result;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });

      return [];
    }
  }

  async getAllRules(): Promise<any[]> {
    try {
      const { data: result } = await api.get<any[]>(`RegraConciliacao/regras/description`, {
        baseURL: process.env.REACT_APP_API_CORE_URL ?? 'https://api-core.dev.painel-agholmes.com/api/v3/'
      });

      return result;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });

      return [];
    }
  }

  async saveRule(data: any): Promise<void> {
    await api.post(`RegraConciliacao`, data, {
      baseURL: process.env.REACT_APP_API_CORE_URL ?? 'https://api-core.dev.painel-agholmes.com/api/v3/'
    });
  }

  async updateRule(id: number, data: any): Promise<void> {
    await api.put(`RegraConciliacao/${id}`, data, {
      baseURL: process.env.REACT_APP_API_CORE_URL ?? 'https://api-core.dev.painel-agholmes.com/api/v3/'
    });
  }
}

export default new RegraConciliacaoService();